import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Image } from 'react-bootstrap';

export default function CardIngredientsDrinks({ index, name }) {
  const history = useHistory();
  const src = `https://www.thecocktaildb.com/images/ingredients/${name}-Small.png`;
  const searchRecipes = async () => {
    history.push('/bebidas');
  };
  return (
    <div data-testid={ `${index}-ingredient-card` } className="recipe-card-custom">
      <div
        className="recipe-card-image-wrapper"
        onClick={ searchRecipes }
        role="button"
        tabIndex={ 0 }
        onKeyPress={ searchRecipes }
        style={ { cursor: 'pointer' } }
      >
        <Image
          alt={ `Ingrediente ${name}` }
          data-testid={ `${index}-card-img` }
          src={ src }
          className="linkImage"
          loading="lazy"
        />
        <div className="recipe-card-badge">
          <span>Ingrediente</span>
        </div>
      </div>
      <div
        className="recipe-card-content"
        onClick={ searchRecipes }
        role="button"
        tabIndex={ 0 }
        onKeyPress={ searchRecipes }
        style={ { cursor: 'pointer' } }
      >
        <h3
          data-testid={ `${index}-card-name` }
          className="recipe-card-title text-center"
        >
          {name}
        </h3>
        <span className="recipe-card-explore justify-content-center">Filtrar bebidas &rarr;</span>
      </div>
    </div>
  );
}

CardIngredientsDrinks.propTypes = {
  index: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
};
